import { get } from 'lodash-es';
import { GetterTree } from 'vuex';
import { i18n } from '@/i18n';
import { ILoginStore } from './shared.types';
import { DEFAULT_DIRECTION, DEFAULT_LOCALE } from './constants';
import { Direction } from '@/store/types';

const sharedGetters: GetterTree<ILoginStore, any> = {
  direction(): Direction {
    return i18n.global.locale.value !== 'he' ? DEFAULT_DIRECTION : Direction.RTL;
  },

  patientFirstName(state): string {
    return get(state, 'metaInfo.firstName', '');
  },

  patientLastName(state): string {
    return get(state, 'metaInfo.lastName', '');
  },

  locale(state): string {
    return state.locale ?? DEFAULT_LOCALE;
  },

  organization(state): any {
    return get(state, 'organization', {});
  },

  organizationName(state): string {
    return get(state, 'organization.name', '');
  },

  organizationLogoUrl(state): string {
    return get(state, 'organization.logo.url', '');
  },

  organizationEmail(state): string {
    return get(state, 'organization.email', '');
  },

  organizationPhoneNumber(state): string {
    return get(state, 'organization.phoneNumber', '');
  },

  phoneNumber(state): string {
    return get(state, 'metaInfo.maskedPhoneNumber', '');
  },

  cookiePolicyUrl(state): string {
    const lang = state.locale;
    const cookiePolicy = state.documents?.cookiePolicy;
    const cookiePolicyOfCurrentLanguage = lang && cookiePolicy?.[lang]?.cookiePolicyUrl;

    return cookiePolicyOfCurrentLanguage || cookiePolicy?.cookiePolicyUrl;
  },

  termsOfUse(state): any {
    const lang = state.locale;
    const termsOfUse = state.documents?.termsOfUse;
    const termsOfUseCurrentLanguage = lang && termsOfUse?.[lang]?.termsOfUseUrl;
    const termsOfUseURL = termsOfUseCurrentLanguage || termsOfUse?.termsOfUseUrl;

    return {
      url: termsOfUseURL,
      version: termsOfUse?.version,
    };
  },
};

export default sharedGetters;
